import { Route } from "@angular/router";
import { AccountPassword } from "./pages/account/password/password.component";
import { UnauthorizedAccessComponent } from "./pages/account/unauthorized/view.component";
import { ClientResponsePage } from "./pages/clientResponse/client.response.component";
import { ClosedAccessComponent } from "./pages/closed/view.component";
import { ClosedNoResponseAccessComponent } from "./pages/closed/viewNoResponse.component";
import { HomeComponent } from "./pages/home/home.component";
import { LoginPage } from "./pages/login/login.component";
import { LogoutPage } from "./pages/logout/logout.component";
import { UserAuth } from "./services/auth/user.auth";
import { PrivacyPolicyPage } from "./pages/privacy-policy/privacy-policy.component";
import { OAuthCallBack } from "./pages/export-setting/oauth-callback.component";

export const appRoutes: Route[] = [
    { path: "home", canActivate: [UserAuth], component: HomeComponent },
    { path: "", redirectTo: "/login", pathMatch: "full" },
    { path: "login", component: LoginPage },
    { path: "response", component: ClientResponsePage },
    { path: "noresponse", component: ClosedNoResponseAccessComponent },
    {
        path: "account/password",
        canActivate: [UserAuth],
        component: AccountPassword,
    },
    { path: "unauthorized", component: UnauthorizedAccessComponent },
    { path: "closed", component: ClosedAccessComponent, data: { title: null } },
    { path: "logout", component: LogoutPage, data: { title: null } },
    { path: "privacy-policy", canActivate: [UserAuth], component: PrivacyPolicyPage, data: { title: null } },
    { path: "authorizecallback", canActivate: [UserAuth], component: OAuthCallBack },
    {
        path: "estimating",
        loadChildren: () =>
            import(
                "./setups/modules/estimating"
            ).then((x) => x.EstimatingModule),
        data: {
            type: "estimating",
            isEstimating: true,
            baseUrl: "/estimating/",
        },
    },
    {
        path: "health-and-safety",
        loadChildren: () =>
            import(
                "./setups/modules/health-and-safety"
            ).then((x) => x.HealthAndSafetyModule),
        data: {
            type: "health-and-safety",
            formArea: "HealthAndSafety",
            baseUrl: "/health-and-safety/",
        },
    },
    {
        path: "locations",
        loadChildren: () =>
            import(
                "./setups/modules/locations"
            ).then((x) => x.LocationsModule),
        data: {
            type: "location",
            baseUrl: "/locations/",
            defaultDisplay: "list",
        },
    },
    {
        path: "offline",
        loadChildren: () =>
            import(
                "./setups/modules/offline"
            ).then((x) => x.OfflineModule),
        data: {
            baseUrl: "/offline/",
        },
    },
    {
        path: "procurement",
        loadChildren: () =>
            import(
                "./setups/modules/procurement"
            ).then((x) => x.ProcurementModule),
        data: { section: "procurement", baseUrl: "/procurement/" },
    },
    {
        path: "projects",
        loadChildren: () =>
            import(
                "./setups/modules/projects"
            ).then((x) => x.ProjectsModule),
        data: {
            type: "general",
            securityLevel: "View",
            baseUrl: "/projects/",
        },
    },
    {
        path: "quality-assurance",
        loadChildren: () =>
            import(
                "./setups/modules/quality-assurance"
            ).then((x) => x.QualityAssuranceModule),
        data: {
            type: "quality-assurance",
            formArea: "quality-assurance",
            baseUrl: "/quality-assurance/",
        },
    },
    {
        path: "qs",
        loadChildren: () =>
            import(
                "./setups/modules/quantity-surveying"
            ).then((x) => x.QuantitySurveyingModule),
        data: {
            type: "quantity-surveying",
            baseUrl: "/qs/",
        },
    },
    {
        path: "settings",
        loadChildren: () =>
            import(
                "./setups/modules/settings"
            ).then((x) => x.SettingsModule),
        data: {
            baseUrl: "/settings/",
        },
    },
    { path: "**", redirectTo: "login?error", pathMatch: "full" },
];
